import React from "react";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Login from "./Login";
const PaymentPage = () => {
  const [showLogin, setShowLogin] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    document.title = "Payment Methods";
  }, []);
  const breadcrumbItems = [
    {
      label: (
        <>
          <i className="bi bi-house"></i> Home
        </>
      ),
      link: "/",
    },
    {
      label: "Payment Methods",
      link: "/payment-method",
    },
  ];
  const handleAddBalance = () => {
    const user = JSON.parse(localStorage.getItem("user"));

    if (user) {
      navigate("/balance");
    } else {
      setShowLogin(true);
    }
  };
  return (
    <div className="paymentPage">
      <div className="container-fluid">
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            {breadcrumbItems.map((item, i) => (
              <li
                key={i}
                className={`breadcrumb-item ${i === breadcrumbItems.length - 1 ? "active" : ""}`}
              >
                {i === breadcrumbItems.length - 1 ? (
                  item.label
                ) : (
                  <a href={item.link}>{item.label}</a>
                )}
              </li>
            ))}
          </ol>
        </nav>
      </div>
      {/* Header */}
      <div className="paymentPage__header">
        <h2 className="paymentPage__title">Pay with PayUmoney</h2>
        <p className="paymentPage__subtitle">
          Add balance securely using multiple payment methods
        </p>
      </div>

      {/* PayU Section */}
      <section className="payuBlock">
        <div className="payuBlock__image">
          <img src="images/payumoney.jpg" alt="PayUmoney" />
        </div>

        <div className="payuBlock__content">
          <p className="payuBlock__text">
            Add Balance Into Your LTC Wallet Using Debit Card, Credit Card, Net
            Banking Or Wallet instantly and securely.
          </p>

          <button className="payuBlock__button" onClick={handleAddBalance}>
            ADD BALANCE
          </button>
        </div>
      </section>

      {/* Payment Details Grid */}
      <section className="paymentGrid">
        {/* Bank Card */}
        <div className="paymentCard bankCard">
          <div className="paymentCard__header">
            <h3>Bank Transfer</h3>
            <span>Call after payment: 9879196990 / 9909614445</span>
          </div>

          <div className="paymentCard__body">
            <div className="infoRow">
              <span className="infoRow__label">Bank Name</span>
              <span className="infoRow__value">Kotak Mahindra</span>
            </div>

            <div className="infoRow">
              <span className="infoRow__label">Account Name</span>
              <span className="infoRow__value">Life Time Creation</span>
            </div>

            <div className="infoRow">
              <span className="infoRow__label">Account No</span>
              <span className="infoRow__value">1312374551</span>
            </div>

            <div className="infoRow">
              <span className="infoRow__label">Account Type</span>
              <span className="infoRow__value">Current Account</span>
            </div>

            <div className="infoRow">
              <span className="infoRow__label">IFSC Code</span>
              <span className="infoRow__value">KKBK0002854</span>
            </div>

            <div className="infoRow">
              <span className="infoRow__label">Branch</span>
              <span className="infoRow__value">Varachha, Surat</span>
            </div>

            <div className="infoRow">
              <span className="infoRow__label">Email</span>
              <span className="infoRow__value">
                lifetime.ltc0777@gmail.com / hareshvaddoriya@gmail.com
              </span>
            </div>
          </div>
        </div>

        {/* Paytm Card */}
        <div className="paymentCard paytmCard">
          <div className="paymentCard__header">
            <h3> Gpay Transfer</h3>
            <span style={{ color: "#c53232" }}>
              Whatsapp Payment Screenshot On 9879196990 / 9909614445 Then Call
            </span>
          </div>

          <div className="paymentCard__body paymentCard__body--center">
            <img
              className="paytmCard__logo"
              src="images/gpay.png"
              alt="Paytm"
            />

            <div className="qrGroup">
              <img src="images/kotak-haresh.jpg" alt="QR 1" />
              {/* <img src="images/payment2.jpg" alt="QR 2" /> */}
            </div>
          </div>
        </div>
      </section>
      <Login isOpen={showLogin} onClose={() => setShowLogin(false)} />
    </div>
  );
};

export default PaymentPage;
